import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  layout: {
    paddingInline: '1rem',
    [theme.breakpoints.up('sm')]: {
      paddingInline: 0,
    },
  },
}));
